import * as React from 'react';

import {CardWidget} from 'shells/card/card-widget/card-widget';

import {EntityPageTimeline} from '../../timeline/entity-page-timeline';
import type {EntityName} from '../../timeline/types';

type Props = {
    entityId: string;
    entityName: EntityName;
    scrollContainerRef: HTMLDivElement | null | undefined;
    hideCreator?: boolean;
    useContainerScroll?: boolean;
};

export function TimelineWidget(props: Props) {
    const {entityId, entityName, scrollContainerRef, hideCreator, useContainerScroll} = props;

    return (
        <CardWidget title='Timeline' type='TIMELINE'>
            <EntityPageTimeline
                entityId={entityId}
                entityName={entityName}
                entityPageName={entityName}
                scrollContainerRef={scrollContainerRef}
                isFullWidth={false}
                hideCreator={hideCreator}
                useContainerScroll={useContainerScroll}
            />
        </CardWidget>
    );
}
